import { DatePicker, Radio } from 'antd';
import { useAppSelector } from 'app/hooks';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import { selectInverterItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import style from './ChartOutputEnergy.module.scss';
export default function ChartOutputEnergy(props) {
  const { fetchDataInverterChart, dataChart } = props;
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const [isPickerTwo, setIsPickerTwo] = useState('hour');
  const [dateTime, setDateTime] = useState(moment().format('YYYY-MM-DD'));
  const [isTitle, setIsTitle] = useState('hourly');

  useEffect(() => {
    if (chartRef && chartRef.current && chartInstance == null) {
      const newChartInstance = new Chart(chartRef.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, []);

  useEffect(() => {
    if (inverterId) {
      setDateTime(moment().format('YYYY-MM-DD'));
      setIsTitle('hourly');
      setIsPickerTwo('hour');
    }
  }, [inverterId]);

  useEffect(() => {
    if (chartInstance) {
      updateDataset(dataChart);
      updateUnit(isTitle);
    }
  }, [dataChart]);

  const updateDataset = (listOne) => {
    chartInstance.data.datasets[0].data = listOne;
    chartInstance.update();
  };

  const updateUnit = (isTitle) => {
    let newUnit = '';
    if (isTitle === 'monthly') {
      newUnit = 'month';
    } else if (isTitle === 'daily') {
      newUnit = 'day';
    } else {
      newUnit = 'hour';
    }
    chartInstance.options.scales.x.time.unit = newUnit;
    chartInstance.update();
  };

  const data = {
    datasets: [
      {
        type: 'bar',
        label: 'Output energy',
        unit: 'kWh',
        data: dataChart,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        backgroundColor: '#038cfc',
        yAxisID: 'y',
      },
    ],
  };

  const chartConfig = {
    data: data,
    options: {
      maintainAspectRatio: false,
      elements: {
        point: {
          radius: 3,
        },
        line: {
          tension: 0.3,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
      plugins: {
        title: {
          text: 'Chart.js Time Scale',
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || '';
              var unit = context.dataset.unit;
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += `${context.parsed.y} ${unit}`;
              }
              return label;
            },
          },
        },
      },
      scales: {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            color: '#191',
            font: {
              family: 'Times',
              size: 20,
              style: 'normal',
              lineHeight: 1.2,
            },
          },
          time: {
            unit: 'hour',
          },
        },
        y: {
          type: 'linear',
          display: true,
          position: 'left',
          title: {
            display: false,
            text: 'Output Energy (kWh)',
            color: '#038cfc',
            font: {
              family: 'Times',
              size: 20,
              style: 'normal',
              lineHeight: 1.2,
            },
          },
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return `${value} kWh`;
            },
          },
        },
      },
    },
  };

  const handlePickerChangeTwo = (e) => {
    // setIsPickerTwo(e.target.value);
    let content = '';
    let time = '';
    if (e.target.value === 'hourly') {
      content = 'date';
      time = `${moment(dateTime).format('YYYY-MM-DD')}`;
    } else if (e.target.value === 'monthly') {
      content = 'year';
      time = `${moment(dateTime).format('YYYY')}`;
    } else {
      content = 'month';
      time = `${moment(dateTime).format('YYYY-MM')}`;
    }
    fetchDataInverterChart(e.target.value, time);
    setIsTitle(e.target.value);
    setIsPickerTwo(content);
  };

  const onChangeDatePicker = async (date) => {
    let time = '';
    if (isTitle === 'hourly') {
      time = `${moment(date).format('YYYY-MM-DD')}`;
    } else if (isTitle === 'daily') {
      time = `${moment(date).format('YYYY-MM')}`;
    } else {
      time = `${moment(date).format('YYYY')}`;
    }
    fetchDataInverterChart(isTitle, time);
    setDateTime(date);
  };

  return (
    <div className="chart-plant-one">
      <div className={style.header_chart}>
        <DatePicker
          picker={isPickerTwo}
          value={moment(dateTime)}
          onChange={onChangeDatePicker}
        />
        <Radio.Group
          style={{ display: 'flex' }}
          value={isTitle}
          onChange={handlePickerChangeTwo}
        >
          <Radio.Button value="hourly">Day</Radio.Button>
          <Radio.Button value="daily">Month</Radio.Button>
          <Radio.Button value="monthly">Year</Radio.Button>
        </Radio.Group>
      </div>
      <div className={style.chart}>
        <canvas ref={chartRef} />
      </div>
    </div>
  );
}
ChartOutputEnergy.propTypes = {
  fetchDataInverterChart: PropTypes.func.isRequired,
  dataChart: PropTypes.arrayOf(
    PropTypes.shape({
      ts: PropTypes.number,
      value: PropTypes.number,
    })
  ).isRequired,
};
